import {reduceResultParams} from "~/reducers/reduceResultParams";
import {modify} from "mythil/object";
import {reduceSearchResults} from "~/rx/search";

export default function reduceSearchModel(model, state, action) {
    model = reduceResultParams(model, action, state);
    model = modify(model, 'results', (results) => reduceSearchResults(results, action, state, model));

    return model;
}